export const edictOfCompulsion = {
  key: 'edict_of_compulsion',
  name: 'Edict of Compulsion',
  category: 'curse',
  description: 'A royal command weighs on the opening move.',
};
